import { momentLocalizer } from 'react-big-calendar'
import { Outlet } from 'react-router-dom'

import moment from 'moment'

import CalendarRoot from 'modules/calendar/components/CalendarRoot'
import { CalendarLeavesProvider } from 'modules/calendar/lib/calendarLeavesContext'
import { LeavesContextProvider } from 'modules/timeoff/lib/LeavesContextProvider'

import CollectionsBootstrap from 'modules/calendar/lib/CollectionsBootstrap'

const RootPage = () => {
  const localizer = momentLocalizer(moment)

  return (
    <CollectionsBootstrap>
      <CalendarRoot>
        {({
          loading,
          filtersForm,
          date,
          range,
          onDateRangeChange,
          canSeeCalendar,
          canSeeJobTitle,
        }) => (
          <LeavesContextProvider>
            <CalendarLeavesProvider momentLocalizer={localizer}>
              <Outlet
                context={{
                  loading,
                  filtersForm,
                  date,
                  range,
                  onDateRangeChange,
                  canSeeCalendar,
                  canSeeJobTitle,
                }}
              />
            </CalendarLeavesProvider>
          </LeavesContextProvider>
        )}
      </CalendarRoot>
    </CollectionsBootstrap>
  )
}

export default RootPage
